import React from "react";

export const PaymentSubmissionSuccess = () => (
  <div>
    <h1 className="mt-5" style={{ textAlign: "center" }}>
      Your payment has been successfully submitted.
    </h1>
    <div className="row justify-content-center">
      <div className="col-auto alert alert-info alert-dismissible fade show mt-2" role="alert">
        Please check the email address you provided for a copy of the receipt.
      </div>
    </div>
  </div>
);
